import React from 'react';

type Props = {
  color?: string
}

const BackArrow: React.FC<Props> = ({ color = 'white' }) => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M3 9H16.5C18.9853 9 21 11.0147 21 13.5C21 15.9853 18.9853 18 16.5 18H12M3 9L7 5M3 9L7 13' stroke={color}
        stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
    </svg>
  );
};

export default BackArrow;